export default (
  ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'chooseImage', 'getLocalImgData', 'uploadImage']
)
